export default {"src":"/_next/static/media/js-logo.32a4fa82.svg","height":630,"width":630,"blurWidth":0,"blurHeight":0};